export default "__VITE_ASSET__DBwWoFUy__"